module.exports = __webpack_public_path__ + "assets/img/bg-line-driver-4eba7574.png";